import { IMAGES, FP_LEVELS } from "./site";

// Detailed content for the service subpages (/tjanster/:slug)
export const SERVICE_PAGES = {
  fonsterputs: {
    slug: "fonsterputs",
    navLabel: "Fönsterputs",
    seo: {
      title: "Fönsterputs i hela Skaraborg – Se Klart Ut",
      description: "Professionell fönsterputs för privatpersoner och företag i hela Skaraborg. Tre nivåer, tillvalet Mellan fönstren och alltid kostnadsfri offert.",
    },
    overline: "Kärntjänst",
    h1: "Fönsterputs i hela Skaraborg",
    intro: "Fönsterputs är vår kärntjänst. Vi putsar för både privatpersoner och företag – villor, lägenheter, kontor och butiker – alltid med noggrant hantverk, modern utrustning och ett streckfritt resultat.",
    image: IMAGES.workTwo,
    imageAlt: "Kristallklart fönster efter putsning av Se Klart Ut",
    levelsIntro: "Tre tydliga nivåer – välj den som passar ditt hem eller din verksamhet.",
    levels: FP_LEVELS,
    addon: {
      title: "Tillval: Mellan fönstren",
      text: "Har du kopplade eller fyrsidiga fönster? Då kan du lägga till putsning av glasytorna mellan fönsterbågarna – ytan som är svår att komma åt själv. Tillvalet kombineras med valfri nivå ovan.",
    },
    includes: [
      "Skinande rena, streckfria glasytor",
      "Noggrant hantverk med professionell utrustning",
      "Anpassat upplägg för hem och verksamheter",
      "Alltid kostnadsfri offert innan vi börjar",
    ],
    faq: [
      { q: "Vilken nivå passar mig?", a: "Utsida räcker långt för de flesta. Vill du ha maximalt ljusinsläpp väljer du In och utsida, och med Premium får du dessutom fönsterkarmarna noggrant rengjorda." },
      { q: "Vad är tillvalet Mellan fönstren?", a: "Det är rengöring av glasytorna mellan bågarna på kopplade eller fyrsidiga fönster – ett tillval som läggs på din valda nivå, aldrig en egen tjänst." },
      { q: "Putsar ni för företag?", a: "Ja, vi hjälper både privatpersoner och företag i hela Skaraborg – från villor till kontor och butiker." },
    ],
  },
  solpaneltvatt: {
    slug: "solpaneltvatt",
    navLabel: "Solpaneltvätt",
    seo: {
      title: "Solpaneltvätt i Skaraborg – Se Klart Ut",
      description: "Skonsam rengöring av solpaneler från smuts, pollen och beläggningar. För privatpersoner och företag i hela Skaraborg – alltid kostnadsfri offert.",
    },
    overline: "Utvändig rengöring",
    h1: "Solpaneltvätt",
    intro: "Smuts, pollen och beläggningar lägger sig på panelerna över tid. Vi rengör dina solpaneler varsamt så att de får stå rena och fria – med samma noggrannhet som vid vår fönsterputs.",
    includes: [
      "Skonsam rengöring av panelernas ytor",
      "Avlägsnar smuts, pollen och beläggningar",
      "Anpassat efter antal paneler och takförhållanden",
      "Alltid kostnadsfri offert innan vi börjar",
    ],
    faq: [
      { q: "Hur vet jag hur många paneler jag har?", a: "Ingen fara – ange ungefär hur många i offertförfrågan så räcker det som utgångspunkt. Vi bekräftar detaljerna när vi återkommer." },
      { q: "Gör ni solpaneltvätt för företag?", a: "Ja, vi hjälper både privatpersoner och företag i hela Skaraborg." },
    ],
  },
  altantvatt: {
    slug: "altantvatt",
    navLabel: "Altantvätt",
    seo: {
      title: "Altantvätt i Skaraborg – Se Klart Ut",
      description: "Vi fräschar upp din altan och tar bort smuts och beläggningar inför säsongen. För privatpersoner och företag i hela Skaraborg – kostnadsfri offert.",
    },
    overline: "Utvändig rengöring",
    h1: "Altantvätt",
    intro: "Altanen samlar smuts och beläggningar mellan säsongerna. Vi tvättar den grundligt så att den känns fräsch och inbjudande igen – redo för sommarens alla stunder.",
    includes: [
      "Grundlig rengöring av altanens ytor",
      "Avlägsnar smuts och beläggningar",
      "Anpassat efter altanens storlek",
      "Alltid kostnadsfri offert innan vi börjar",
    ],
    faq: [
      { q: "Hur stor altan klarar ni?", a: "Berätta ungefär hur stor altanen är i förfrågan – till exempel 'ca 20 kvm' – så tar vi fram ett upplägg som passar." },
      { q: "När på året passar altantvätt?", a: "Många bokar inför säsongen, men hör av dig när det passar dig så hittar vi en tid." },
    ],
  },
  marktvatt: {
    slug: "marktvatt",
    navLabel: "Marktvätt",
    seo: {
      title: "Marktvätt i Skaraborg – Se Klart Ut",
      description: "Rengöring av uppfarter, gångar och andra hårda ytor. För privatpersoner och företag i hela Skaraborg – alltid kostnadsfri offert.",
    },
    overline: "Utvändig rengöring",
    h1: "Marktvätt",
    intro: "Uppfarter, gångar och andra hårda ytor tar stryk av väder och vind. Vi rengör dem noggrant så att entrén till ditt hem eller din verksamhet gör ett välskött intryck.",
    includes: [
      "Rengöring av uppfarter, gångar och hårda ytor",
      "Avlägsnar smuts och missfärgningar",
      "Anpassat efter ytans storlek och material",
      "Alltid kostnadsfri offert innan vi börjar",
    ],
    faq: [
      { q: "Vilka ytar tvättar ni?", a: "Uppfarter, gångar och andra hårda ytor. Beskriv gärna ytan och ungefärlig storlek i förfrågan – till exempel 'uppfart, ca 60 kvm'." },
      { q: "Gör ni marktvätt för företag?", a: "Ja, vi hjälper både privatpersoner och företag i hela Skaraborg." },
    ],
  },
};

export const SERVICE_SLUGS = Object.keys(SERVICE_PAGES);
